export type AgendaColumn = {
  label: string;
  practitionerId?: string;
  practitionerUserId?: string;
};

// Keep the existing provider IDs and column order; filters change visibility only.
export const AGENDA_COLUMNS: readonly AgendaColumn[] = [
  { label: 'TM', practitionerId: 'data_c_10', practitionerUserId: 'data_c_user_10' },
  { label: 'BW', practitionerId: 'data_c_11', practitionerUserId: 'data_c_user_11' },
  { label: 'NR', practitionerId: 'data_c_12', practitionerUserId: 'data_c_user_12' },
  { label: 'MW', practitionerId: 'data_c_13', practitionerUserId: 'data_c_user_13' },
  { label: 'LK', practitionerId: 'data_c_14', practitionerUserId: 'data_c_user_14' },
  { label: 'Zaz', practitionerId: 'data_c_15', practitionerUserId: 'data_c_user_15' },
  { label: 'BRIEFING' },
];

type AgendaFilter = { label: string; columns: readonly string[] | null; aliases?: readonly string[] };

export const AGENDA_FILTERS: readonly AgendaFilter[] = [
  { label: 'Alle', columns: null },
  { label: 'TM', columns: ['TM'] },
  { label: 'BW', columns: ['BW'] },
  { label: 'NR', columns: ['NR'] },
  { label: 'MW', columns: ['MW'] },
  { label: 'LK', columns: ['LK'] },
  { label: 'Zaz', columns: ['TM', 'BW', 'NR'] },
  { label: 'DH+PA', columns: ['MW', 'LK'] },
  { label: "DH's", aliases: ['DH'], columns: ['MW'] },
  { label: "PA's", aliases: ['PA'], columns: ['LK'] },
  { label: 'Briefing', columns: ['BRIEFING'] },
];

export const getVisibleAgendaColumns = (filter: string): readonly AgendaColumn[] => {
  const selection = AGENDA_FILTERS.find((item) => item.label === filter || item.aliases?.includes(filter));
  const columns = selection?.columns;
  return columns
    ? AGENDA_COLUMNS.filter((column) => columns.includes(column.label))
    : AGENDA_COLUMNS;
};

export const AGENDA_START_HOUR = 6;
export const AGENDA_END_HOUR = 19;
export const AGENDA_INTERVAL_MINUTES = 5;
export const AGENDA_TOTAL_MINUTES = (AGENDA_END_HOUR - AGENDA_START_HOUR) * 60;
export const AGENDA_INTERVAL_COUNT = AGENDA_TOTAL_MINUTES / AGENDA_INTERVAL_MINUTES;
